import { PublicTemplate } from "@components/templates/public";
import { useEffect, useState } from "react";
import { useForm } from "@refinedev/react-hook-form";
import { GoogleFormComponent, GoogleFormStatus, useGoogleForm } from "@components/organisms/GoogleForm";

export function Onboarding() {
    enum Status {
        GoogleForm,
        SendEmail,
        SaysGoodbye,
    };

    const [status, setStatus] = useState(Status.GoogleForm);
    const { loading, status: formStatus } = useGoogleForm()
    const [showLoading, setShowLoading] = useState(true);
    
    // Loading 3 sg
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoading(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);
    
    // logger.debug('status', formStatus)

    const {
        refineCore: { onFinish, formLoading, mutationResult },
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        refineCoreProps: {
            resource: "onboarding_registry",
            meta: {
                fields: ["id"]
            }
        },
    });

    useEffect(() => {
        if (formStatus == GoogleFormStatus.end) {
            setStatus(Status.SaysGoodbye);
        }
    }, [formStatus]);

    useEffect(() => {
        if (mutationResult.isSuccess) {
            setStatus(Status.SaysGoodbye);
        }
    }, [mutationResult]);

    const EmailForm = () => <div className="flex flex-col items-center justify-center w-full h-full p-8">
        <div className="card w-full max-w-md bg-base-100 shadow-xl">
            <figure className="px-10 pt-10">
                <img src="/img/hachi-corner.png" alt="Hachi" className="w-20 h-20" />
            </figure>
            <div className="card-body">
                <h1 className="card-title text-2xl font-bold justify-center mb-4">Último paso</h1>
                <p className="text-base-content/70 mb-4 text-center">
                    Para garantizar tu identidad y corroborar requisitos legales,
                    necesitamos adicionalmente unos datos qué te pediremos a través de tu correo.
                </p>
                <form onSubmit={handleSubmit(onFinish)} className="space-y-4">
                    <div className="form-control">
                        <input 
                            type="email"
                            className="input input-bordered w-full" 
                            placeholder="tu@correo.com"
                            {...register("email", { required: true })} 
                        />
                        {errors.email && <span className="text-error text-sm">Campo requerido</span>}
                    </div>
                    <button 
                        type="submit" 
                        className={`btn btn-primary w-full ${formLoading ? 'loading' : ''}`}
                    >
                        Enviar
                    </button>
                </form>
            </div>
        </div>
    </div>;

    const GoodByeAnouncement = () => <div className="flex flex-col items-center justify-center w-full h-full p-8">
        <div className="card w-full max-w-md bg-base-100 shadow-xl">
            <figure className="px-10 pt-10">
                <img src="/img/hachi-corner.png" alt="Hachi" className="w-20 h-20" />
            </figure>
            <div className="card-body text-center">
                <div className="text-6xl mb-4">✅</div>
                <h1 className="card-title text-2xl font-bold justify-center mb-4">¡Completado!</h1>
                <p className="text-base-content/70">Revisa tu correo para los siguientes pasos.</p>
            </div>
        </div>
    </div>;

    return <PublicTemplate>
        <div className="flex-1 flex items-center justify-center">
            {{
                [Status.GoogleForm]: showLoading ? (
                    <GoogleFormComponent
                        loading={loading}
                        status={formStatus}
                        googleFormID="1FAIpQLScmOmvF-v0UxzN3bV84hJU6oIN1fXX51nRNfDr3BzfrVV07fQ"
                        className="w-full h-full"
                    />
                ) : (
                    <div className="flex flex-col items-center justify-center w-full h-full p-8">
                        <div className="card w-full max-w-md bg-base-100 shadow-xl">
                            <figure className="px-10 pt-10">
                                <img src="/img/hachi-corner.png" alt="Hachi" className="w-20 h-20" />
                            </figure>
                            <div className="card-body text-center">
                                <h1 className="card-title text-2xl font-bold justify-center mb-4">Registro Profesional</h1>
                                <p className="text-base-content/70 mb-4">
                                    Para comenzar tu registro como profesional, necesitamos algunos datos y documentos.
                                </p>
                                <a 
                                    href="https://docs.google.com/forms/d/e/1FAIpQLSduobXmg4Gs1DrBDFG5je_ksV_ozcVK0nP5PtbtrbwoHHknhg/viewform?usp=dialog"
                                    target="_blank"
                                    className="btn btn-primary w-full mb-4"
                                    onClick={() => setStatus(Status.SaysGoodbye)}
                                >
                                    Abrir Formulario
                                </a>
                                <div className="flex items-center justify-center gap-2 rounded-lg">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-current shrink-0 w-5 h-5 text-base-content/70">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <span className="text-sm text-base-content/70">Se abrirá en una nueva ventana</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ),
                [Status.SendEmail]: <EmailForm />,
                [Status.SaysGoodbye]: <GoodByeAnouncement />,
            }[status]}
        </div>
    </PublicTemplate>;
}
